import { Component, OnInit, ViewChild, HostListener, AfterViewInit, ChangeDetectorRef, Input } from '@angular/core';
import { ProductoService } from '../../producto.service';
import { Producto } from '../../producto';
import { MdbTablePaginationComponent, MdbTableDirective, ModalDirective } from 'angular-bootstrap-md';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Impuesto } from '../../Impuesto';
import { ImpuestoService } from '../../impuesto.service';
import * as XLSX from 'xlsx';  
import { AlertService } from 'ngx-alerts';

import { UnidadService } from '../../unidad.service';
import { Unidades } from '../../unidades';
import { ProductoPrecio } from '../../productoPrecio';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-kardex',
  templateUrl: './kardex.component.html',
  styleUrls: ['./kardex.component.scss']
})
export class KardexComponent  implements OnInit {

 
  productos: Producto[];
  impuestos: Impuesto[];
  unidades: Unidades[];
  unidadesVenta: Unidades[];
  precio: ProductoPrecio;
  listaPrecios: ProductoPrecio[];
  listaPreciosActualizar: ProductoPrecio[]  = [];
  productoActuliza: Producto;
  listaClientesActulizar: Producto[] = [];
  selecProduc: Producto;
  editForm: FormGroup;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;



  data: Producto[] = [];
  previous: any = [];
  isLoadingResults = true;
  fileName= 'Productos.xlsx';  
  printWindow:Window;
  url:string;

  etiqueta(){
 
    

  }



listarUnidades()
{

  this.apiUnidad.getUnidadesCompra(localStorage.getItem('id')).subscribe((
    data: Unidades[]) => {
    this.unidades = data;
    console.log(this.unidades);
    
  }
    , err => {
      console.log(err);
      
    });

}

elimiarPrecio(varPrecios:ProductoPrecio){
  this.api.eliminarPrecio(varPrecios.id).subscribe(
  data  => {
    this.alertService.success("Se elimino con exito..");
    this.listaProductoPrecio();
  },
  
  error  => {
  
 this.alertService.danger(error);
  
  });
}


listarUnidadesVenta()
{

  this.apiUnidad.getUnidadesVenta(localStorage.getItem('id')).subscribe((
    data: Unidades[]) => {
    this.unidadesVenta = data;
    console.log(this.unidadesVenta);
    
  }
    , err => {
      console.log(err);
      
    });

}

  constructor(private apiUnidad: UnidadService,private alertService: AlertService,private apiImpuesto: ImpuestoService, private api: ProductoService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder, private ruter: Router) { }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }


  imprimirEtiqueta(texto){
    const printContent = document.getElementById(texto);
   this.printWindow = window.open();
   this. printWindow.document.open('text/plain')
   this. printWindow.document.write("^XA^FXTest ZPL^FS^FO50,100^A0N,89^FDHello ZPL^FS^XZ");
   this.  printWindow.document.close();
   this.  printWindow.focus();
   this.  printWindow.print();
   this.  printWindow.close();
    
  }
  ngAfterViewInit() {

    this.cdRef.detectChanges();
  }

  validarNumeros(numero){
    if (!numero){
      return 0;
    }else{
      return numero;
    }
  }

  ngOnInit() {
    this.precio= new ProductoPrecio();
    this.selecProduc= new Producto();
 
    this.listarUnidades();
    this.api.getProductoInventario(localStorage.getItem('id'))
      .subscribe((
        data: Producto[]) => {
        this.productos = data;
        console.log(this.productos);
        this.productos.forEach(element => {
          element.stock=this.validarNumeros(element.stock)
         if (element.stock<2){
          element.color="yellow"
         }else{
          element.color="none"
         }
         }
        );
        this.mdbTable.setDataSource(this.productos);

        this.previous = this.mdbTable.getDataSource();
  
        }, err => {
          console.log(err);
          this.isLoadingResults = false;
        });

        

    this.editForm = this.formBuilder.group({
      codigo: ["", [Validators.required, Validators.maxLength(4),Validators.min(1)]],

      codigoPrincipal: [["", Validators.required,Validators.maxLength(4),Validators.min(1)]],
      codigoAuxiliar: ["", Validators.required],
      nombre: ["", Validators.required],
      valorUnitario: [0, Validators.required],
      valorCaja: [0, ],
      valorLibra: [0, ],
      idUnidad: [0, ],
      tipoProducto: ["", Validators.required],
      iva: ["", Validators.required],
      ice: [0, Validators.required],
      irbpnr: ["", Validators.required]
    });


  }


  exportexcel() 
    {
       /* table id is passed over here */   
       const element = document.getElementById('mdbTable'); 
       const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

       /* generate workbook and add the worksheet */
       const wb: XLSX.WorkBook = XLSX.utils.book_new();
       XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

       /* save to file */
       XLSX.writeFile(wb, this.fileName);
			
    }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.productos = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.productos = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

  eliminarProducto(id: number) {
    this.api.eliminarProducto(id).subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..");
      
      },
      
      error  => {
      
     this.alertService.danger(error);
      
      }
      
      );
 
 

  }

  listaProductoPrecio(){
    this.api.getProductoPrecio(this.precio.idProducto.toString(), localStorage.getItem('id'))
    .subscribe((
      data: ProductoPrecio[]) => {
      this.listaPrecios = data;
      console.log(this.listaPrecios);
    }
      , err => {
        console.log(err);
        this.isLoadingResults = false;
      });
      
   
  }

  agregarPrecios(){
    this.listaProductoPrecio();
    this.precio.id=0;
    this.listaPreciosActualizar[0] = this.precio;
    this.api.setActulizarProductoPrecio(this.listaPreciosActualizar)
    .subscribe(

      data  => {
        this.alertService.success("Se guardo con exito...");
        this.api.getProductoPrecio(this.precio.idProducto.toString(), localStorage.getItem('id'))
        .subscribe((
          data: ProductoPrecio[]) => {
          this.listaPrecios = data;
          console.log(this.listaPrecios);
         
         
        }
          , err => {
            console.log(err);
            this.isLoadingResults = false;
          });
        },
      
        error  => {
        
       this.alertService.danger(error)
        
        }
        
        );
       

  
  }
  

  


  listarImpuesto() {
    this.apiImpuesto.getImpuestos().subscribe((
      data: Impuesto[]) => {
      this.impuestos = data;
    });
  }



  mensaje(varPrododucto: Producto) {


    this.url=environment.apiReportes+"kardex.rptdesign&productoId="+varPrododucto.codigo;
    window.open(this.url, '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    

  }

}
